import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=2343f2f2&scoped=true&"
import script from "./mainBody.vue?vue&type=script&lang=js&"
export * from "./mainBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343f2f2",
  null
  
)

export default component.exports